import React from 'react'
import { Container } from 'reactstrap'


import "../../style/common-section.css"


const ShopSection = ({title}) => {
  return (
   <section className="common__section">
    <Container className='text-center'>
        <h1>{title}</h1>
    </Container>
   </section>
  )
}

export default ShopSection